module.exports = __webpack_public_path__ + "static/media/logohome.6955e036.png";